import { forwardRef, type SVGProps } from 'react';

export interface PointerProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const Pointer = forwardRef<SVGSVGElement, PointerProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 16 16">
    <path
      clipRule="evenodd"
      d="M5.13557 2.74967L5.6167 12.7572L7.87582 9.4422C8.07604 9.14839 8.40859 8.97259 8.76414 8.97259H12.8682L5.13557 2.74967ZM3.97888 2.63829C3.93437 1.71228 5.00438 1.16795 5.72662 1.74918L13.755 8.2101C14.5454 8.84622 14.0956 10.1226 13.081 10.1226H8.80379L6.44087 13.5899C5.85992 14.4423 4.52832 14.0665 4.47878 13.0361L3.97888 2.63829Z"
      fillRule="evenodd"
    />
  </svg>
));
Pointer.displayName = 'Pointer';
